import { Link, usePage } from "@inertiajs/react";
import { MenuIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Sheet, SheetClose, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { dashboardPath, signInPath } from "@/routes";

import AppLogo from "./app-logo";

export default function PublicHeader() {
  const { auth } = usePage().props;

  const marketingLinks = [
    { label: "Features", href: "/#feature-buckets" },
    { label: "Case Studies", href: "/#case-studies" },
    { label: "Pricing", href: "/#pricing" },
    { label: "FAQ", href: "/#faq" },
    { label: "Docs", href: "/docs" },
    { label: "One-click generation", href: "/new" },
  ];

  return (
    <header className="container mx-auto flex max-w-6xl items-center justify-between px-4 py-4">
      <AppLogo />

      <nav className="hidden items-center gap-4 md:flex">
        {marketingLinks.map((link) => (
          <Link
            key={link.href}
            href={link.href}
            className="text-sm font-medium text-gray-600 transition-colors duration-200 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white"
          >
            {link.label}
          </Link>
        ))}
        {auth?.user ? (
          <Link
            href={dashboardPath()}
            className="inline-flex transform items-center rounded-lg bg-gradient-to-r from-orange-500 to-red-500 px-4 py-1 text-sm font-medium text-white shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl"
          >
            Dashboard
          </Link>
        ) : (
          <>
            <Link
              href={signInPath()}
              className="inline-flex items-center rounded-lg border border-gray-200 px-4 py-1 text-sm font-medium text-gray-700 transition-all duration-200 hover:border-gray-300 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
            >
              Log in
            </Link>
          </>
        )}
      </nav>

      <div className="md:hidden">
        <Sheet>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon">
              <MenuIcon className="size-5" />
              <span className="sr-only">Toggle navigation</span>
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="flex flex-col gap-6 p-0">
            <SheetHeader className="border-b p-4">
              <SheetTitle className="sr-only">Main navigation</SheetTitle>
              <AppLogo />
            </SheetHeader>
            <div className="flex flex-1 flex-col gap-3 px-4 pb-6">
              {marketingLinks.map((link) => (
                <SheetClose asChild key={link.href}>
                  <Link
                    href={link.href}
                    className="inline-flex items-center justify-center rounded-lg border border-gray-200 px-4 py-2 text-sm font-medium text-gray-700 transition-colors duration-200 hover:border-gray-300 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
                  >
                    {link.label}
                  </Link>
                </SheetClose>
              ))}
              {auth?.user ? (
                <SheetClose asChild>
                  <Link
                    href={dashboardPath()}
                    className="inline-flex transform items-center justify-center rounded-lg bg-gradient-to-r from-orange-500 to-red-500 px-4 py-1 text-sm font-medium text-white shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl"
                  >
                    Dashboard
                  </Link>
                </SheetClose>
              ) : (
                <>
                  <SheetClose asChild>
                    <Link
                      href={signInPath()}
                      className="inline-flex items-center justify-center rounded-lg border border-gray-200 px-4 py-1 text-sm font-medium text-gray-700 transition-all duration-200 hover:border-gray-300 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
                    >
                      Log in
                    </Link>
                  </SheetClose>
                </>
              )}
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
